module.exports = __webpack_public_path__ + "img/Differentiation-PRCA_10X_ANS.6e841396.png";